import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77ad27dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "linkard_item_bg" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "linkard_name" }
const _hoisted_4 = { class: "linkard_tags" }
const _hoisted_5 = { class: "linkard_tags_bg" }
const _hoisted_6 = { class: "linkard_avatar" }
const _hoisted_7 = { class: "linkard_path" }
const _hoisted_8 = { class: "qr_code_image_bg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.linkardInfo.avatar,
      alt: "",
      class: "linkard_logo"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.linkardInfo.name), 1),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkardInfo.tags, (item, index) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_5, [
          item
            ? (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(item), 1))
            : _createCommentVNode("", true)
        ]))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.linkardInfo.npcAvatar)
        ? (_openBlock(), _createBlock(_component_el_image, {
            key: 0,
            src: _ctx.linkardInfo.npcAvatar,
            fit: "cover"
          }, null, 8, ["src"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.linkardQRImgUrl), 1),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_vue_qrcode, {
        value: _ctx.linkardQRImgUrl,
        color: {},
        type: "image/png",
        width: 32,
        height: 32,
        margin: 0,
        errorCorrectionLevel: "L"
      }, null, 8, ["value"])
    ]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}